import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Route, withRouter } from "react-router-dom";

import { withStyles } from "@material-ui/core";
import withWidth from "@material-ui/core/withWidth/withWidth";

import StudentTopBar from "./StudentTopBar";
import StudentMenu from "./StudentMenu";
import StudentPolls from "./StudentPolls";
import Screenshots from "./Screenshots";

import {
  listenCourseActivity,
  listenPollStudents,
  fetchCourses,
  fetchCourse,
  fetchPoll,
  saveStudentCourse,
  updateCourseStudent,
  getScreenshotURLs,
  editAccount,
  setPollStudent,
  signOut,
  listenPoll,
  fetchPollStudents,
  listenSessionActivity,
  fetchAnonCourses,
} from "../firebaseApi";
import { changeCourses, changePolls, changeAccount, changeCourseID } from "../redux";
import { responsiveProperty } from "@mui/material/styles/cssUtils";

const styles = (theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  grow: {
    flexGrow: 1,
  },
  bottomBar: {
    top: "auto",
    bottom: 0,
  },
  accountListItem: {
    height: 64,
    width: 256,
  },
});

function Student(props) {
  const [userMenuOpen, setUserMenuOpen] = React.useState(true);
  const [poll, setPoll] = React.useState(null);
  const [screenshotURLs, setScreenshotURLs] = React.useState([]);
  const [studentLocation, setStudentLocation] = React.useState(null);
  const [loadingStudentLocation, setLoadingStudentLocation] =
    React.useState(false);
  const [sessionObject, setSessionObject] = React.useState({
    sessionOverrideLive: false,
  });
  const [courseObject, setCourseObject] = React.useState(null);
  const [refresh, setRefresh] = React.useState(false);
  const [refreshCourse, setRefreshCourse] = React.useState(false);
  const [studentCategories, updateStudentCategories] = React.useState({});
  const [anonCourses, setAnonCourses] = React.useState({});

  let urlParams = props.match.params;
  let { courses } = props;

  const handleStudentGeolocation = async () => {
    setLoadingStudentLocation(true);

    try {
      if ("geolocation" in navigator) {
        const position = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(
            (position) => resolve(position),
            (error) => reject(error)
          );
        });

        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        setStudentLocation({ latitude, longitude });

        return { latitude, longitude };
      } else {
        //console.log("Geolocation not available");
      }
    } catch (error) {
      //console.log(error);
    } finally {
      setLoadingStudentLocation(false);
    }
  };

  const handleEndStudentGeolocation = () => {
    setStudentLocation(null);
  };

  React.useEffect(() => {
    if (props.account.accountEmail && props.selRole === "student") {
      try {
        let data = { accountID: props.account.accountID, selRole: "student" };
        fetchCourses(data).then((courses) => {
          props.changeCourses(courses);
          fetchAnonCourses({accountID: props.account.accountID}).then((anonCourses) => {
            setAnonCourses(anonCourses);
          });
        });
      } catch (err) {
        console.log(err);
      }
    }
  }, [props.selRole]);

  React.useEffect(() => {
    if (urlParams.courseID || props.courseID) {
      let data = { courseID: props.courseID !== "" ? props.courseID : urlParams.courseID };
      let unsub = listenCourseActivity(data, (updatedCourse) => {
        let newCourses = Object.assign({}, courses);
        newCourses[data.courseID] = updatedCourse;
        props.changeCourses(newCourses);
        setCourseObject(updatedCourse);
        let route = "/student/" + updatedCourse.courseID;
        
        if ((updatedCourse.courseActivityPollLive || updatedCourse.courseActivityPollDisplay) && updatedCourse.courseActivityPollID) {
          // route = updatedCourse.courseActivityPollID
          // ? route + "/" + updatedCourse.courseActivityPollID
          // : route;
          route = route + "/" + updatedCourse.courseActivityPollID;
          props.history.push(route);
        } else {
          props.history.push(route);
        }

        if (
          updatedCourse.courseActivitySessionID &&
          updatedCourse.screenshotsEn
        ) {
          setTimeout(() => {
            let data = {
              accountEmail: updatedCourse.courseInstructorID,
              sessionID: updatedCourse.courseActivitySessionID,
              ordered: true,
            };
            getScreenshotURLs(data).then((urls) => {
              setScreenshotURLs(urls);
            });
          }, 1500);
        }

        if (!updatedCourse.courseActivityPollID) {
          setPoll(null);
        }
      });

      if (props.courseID !== "") {
        
        if (props.width === "sm" || props.width === "xs") {
          setUserMenuOpen(false);
        }
        
        props.changeCourseID("");
      }
      return unsub;
    }
  }, [urlParams.courseID, refreshCourse]);

  React.useEffect(() => {
    
    if (courseObject?.courseActivityLastSessionID) {
      let data = { sessionID: courseObject.courseActivityLastSessionID };

      let unsub = listenSessionActivity(data, (updatedSession) => {
        setSessionObject(updatedSession);
      });

      return unsub;
    }
  }, [courseObject, refresh]);

  React.useEffect(() => {
    
    if (urlParams.pollID) {
      let data = { pollID: urlParams.pollID };
      let unsub = listenPollStudents(data, (updatedPollStudents) => {
        fetchPoll(data).then((poll) => {
          let newPoll = poll;
          newPoll["students"] = updatedPollStudents;
          console.log("SEtting poll 1");
          setPoll(newPoll);
        });
      });

      let unsubPoll = listenPoll(data, (newPoll) => {
        fetchPollStudents({ pollID: newPoll.pollID }).then((students) => {
          newPoll["students"] = students;
          console.log("SEtting poll 2");
          setPoll(newPoll);
        });
      });

      return () => {
        unsub();
        unsubPoll();
      };
    }
  }, [urlParams.pollID]);

  function enrollStudent(courseID) {
    if (props.account.accountEmail) {
      let data = {
        accountID: props.account.accountID,
        courseID: courseID,
        firstName: props.account.accountFirstName,
        lastName: props.account.accountLastName,
        // identifier: props.account.identifier,
      };

      return saveStudentCourse(data)
        .then(() => {
          let data = { accountID: props.account.accountID, selRole: "student" };
          return fetchCourses(data);
        })
        .then((courses) => {
          props.changeCourses(courses);
        });
    } else {
      let data = { courseID };
      return fetchCourse(data).then((course) => {
        props.changeCourses(course);
      });
    }
  }

  function editStudentCourseInfo(courseID, newiClicker) {
    let data = {
      courseID: courseID,
      accountID: props.account.accountID,
      iClicker: newiClicker,
    };

    return updateCourseStudent(data)
      .then(() => {
        let data = { accountID: props.account.accountID, selRole: "student" };
        return fetchCourses(data);
      })
      .then((courses) => {
        props.changeCourses(courses);
      });
  }
  function changeActiveCourse(newActiveCourse){
    setCourseObject(newActiveCourse);
  }
  // function editStudentInfo(firstName, lastName, identifier) {
  function editStudentInfo(firstName, lastName) {
    let data = {
      accountID: props.account.accountID,
      accountEmail: props.account.accountEmail,
      accountFirstName: firstName,
      accountLastName: lastName,
      // accountIdentifier: identifier,
      accountType: props.account.accountType,
    };

    return editAccount(data).then(() => {
      props.changeAccount(data);
    });
  }

  function refreshScreenshots() {
    if (props.courses[urlParams.courseID].courseActivitySessionID) {
      let data = {
        accountEmail: props.courses[urlParams.courseID].courseInstructorID,
        sessionID: props.courses[urlParams.courseID].courseActivitySessionID,
        ordered: true,
      };
      getScreenshotURLs(data).then((urls) => {
        setScreenshotURLs(urls);
      });
    }
  }

  function refreshSessionListen() {
    setRefresh(!refresh);
  }

  function refreshCourseListen(courseID) {
    setRefreshCourse(!refreshCourse);
    if (urlParams.courseID != courseID) {
      let data = { accountID: props.account.accountID, selRole: "student" };
      fetchCourses(data).then((courses) => {
        props.changeCourses(courses);
      });
    }
  }

  function setVote(data) {
    let pollData = {
      pollID: data.pollID ?? poll.pollID,
      studentID: props.account.accountID,
      vote: data.choice,
    };

    if (!props.account.accountEmail) {
      data["studentCategories"] = studentCategories;
    }
    return setPollStudent(pollData);
  }

  return (
    <>
   
      <Route
        path="/student/:courseID?/:pollID?"
        render={() => (
          <StudentTopBar
            userMenuOpen={userMenuOpen}
            userMenuOpenCtl={(open) => setUserMenuOpen(open)}
            handleStudentGeolocation={handleStudentGeolocation}
            handleEndStudentGeolocation={handleEndStudentGeolocation}
            studentLocation={studentLocation}
            loadingStudentLocation={loadingStudentLocation}
            currentCourseName={
              urlParams.courseID
                ? courses[urlParams.courseID].courseName
                : undefined
            }
            pollLive={
              urlParams.courseID
                ? courses[urlParams.courseID].courseActivityPollLive
                : false
            }
            pollID={
              urlParams.courseID
                ? courses[urlParams.courseID].courseActivityPollID
                : false
            }
          />
        )}
      />

      <Route
        path="/student/:courseID?/:pollID?"
        render={() => (
          <StudentMenu
            open={userMenuOpen}
            openCtl={(open) => setUserMenuOpen(open)}
            account={props.account}
            courses={props.courses}
            anonCourses={anonCourses}
            taCourses = {{test:"TestCourse"}}
            urlParams={urlParams}
            enrollStudent={enrollStudent}
            editStudentCourseInfo={editStudentCourseInfo}
            editStudentInfo={editStudentInfo}
            changeActiveCourse = {changeActiveCourse}
            refreshCourseListen={(courseID) => refreshCourseListen(courseID)}

            logout={() => {
              signOut().then(() => {
                props.changeAccount({});
                props.history.push("/login");
              });
            }}
            lotProps = {props}
          />
        )}
      />

      <Route
        path="/student/:courseID/:pollID?"
        render={() => (
          <StudentPolls
            account={props.account}
            course={courses[urlParams.courseID]}
            session={sessionObject}
            userMenuOpen={userMenuOpen}
            poll={poll}
            live={courses[urlParams.courseID].courseActivityPollLive}
            showDisplay={courses[urlParams.courseID]?.courseActivityPollDisplay}
            handleStudentGeolocation={handleStudentGeolocation}
            handleEndStudentGeolocation={handleEndStudentGeolocation}
            studentLocation={studentLocation}
            loadingStudentLocation={loadingStudentLocation}
            screenshotURL={
              courses[urlParams.courseID].screenshotsEn
                ? screenshotURLs.slice(-1)[0]
                : null
            }
            screenshotEn={courses[urlParams.courseID].screenshotsEn}
            vote={
              poll
                ? poll.students[props.account.accountID]
                  ? poll.students[props.account.accountID].studentVote
                  : ""
                : ""
            }
            setVote={setVote}
            refreshSessionListen={refreshSessionListen}
            studentCategories={studentCategories}
            updateStudentCategories={(newCategories) => updateStudentCategories(newCategories)}
          />
        )}
      />
      
      {/* <Route
        path="/student/:courseID/:pollID?"
        render={() =>
          props.courses[urlParams.courseID].screenshotsEn ? (
            <Screenshots
              sessionActive={Boolean(
                props.courses[urlParams.courseID].courseActivitySessionID
              )}
              userMenuOpen={userMenuOpen}
              urls={screenshotURLs}
              refresh={refreshScreenshots}
            />
          ) : null
        }
      /> */}
    </>
  );
}

const mapStateToProps = (state) => {
  return { courses: state.courses, account: state.account, courseID: state.courseID, selRole: state.selRole };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeCourses: (data) => dispatch(changeCourses(data)),
    changePolls: (data) => dispatch(changePolls(data)),
    changeAccount: (data) => dispatch(changeAccount(data)),
    changeCourseID: (data) => dispatch(changeCourseID(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withStyles(styles, { withTheme: true })(withWidth()(Student))));
